import {
  StyledAppLoadingSpinner,
  StyledSpinner
} from './AppLoadingSpinner.styled';

export default function LoadingSpinner() {
  return (
    <StyledAppLoadingSpinner>
      <StyledSpinner src='/assets/app_loading.gif'/>
    </StyledAppLoadingSpinner>
  );
}
